import { uiSize } from '@utils'

interface Props {
  size?: number | string
}

function TransactionsIcon({ size }: Props) {
  return (
    <svg
      width={uiSize(size)}
      height={uiSize(size)}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
    >
      <path d='M21 12H3M21 6H3M21 18H3' />
    </svg>
  )
}

export default TransactionsIcon
